import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Button from '../Button/Button';
import Group from './Group';
import Input from '../Input/Input';

export default class GroupExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
      level: 3,
      title: 'Group 1'
    };
  }

  onChange = e => this.setState(e.target.value);

  render() {
    const { className = 'group-1' } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Group.defaultProps} propTypes={Group.propTypes} propValues={this.state}/>
        <div className="groups">
          <Group {...this.state}>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&#8217;s
              standard dummy text ever since the 1500s.
            </p>
            <p>
              It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
              recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </p>
          </Group>
          <Group title="Group 2">
            <Button className="primary">Primary</Button>
            <Button>Secondary</Button>
            <Button className="tertiary">Tertiary</Button>
          </Group>
          <Group title="Group 3">
            <Input label="First Name"/>
            <Input label="Family Name" errorMessage="This is an error message"/>
            <Input placeholder="No label"/>
            <Button>Submit</Button>
          </Group>
        </div>
        <SourceCode querySelector={`.${className}`}/>
      </Example>
    );
  }

}
